// SPA mode. There is no server: no SSR, no prerendering, no server load
// functions anywhere in this project. SPEC §1.1.
export const ssr = false;
export const prerender = false;

// The whole app is one shell; keep client-side routing on.
export const trailingSlash = 'never';
